var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left-to-line (Deposit icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5781 27.0982C18.9323 27.4898 19.4531 27.7143 20 27.7143C20.5469 27.7143 21.0661 27.4899 21.4323 27.0896L27.7969 19.97C28.3354 19.385 28.4823 18.5284 28.1729 17.7859C27.8594 17.0482 27.1562 16.5714 26.375 16.5714L23.3333 16.5768V10.4C23.3333 9.07678 22.2865 8 21 8H19C17.7135 8 16.6667 9.07678 16.6667 10.4V16.5768L13.625 16.5714C12.8438 16.5714 12.1391 17.0485 11.8266 17.7902C11.5173 18.5295 11.6638 19.3855 12.1944 19.9625L18.5781 27.0982ZM13.3542 18.4679C13.401 18.3554 13.5104 18.2857 13.625 18.2857H18.3333V10.4C18.3333 10.0196 18.6354 9.71428 19 9.71428H20.999C21.3698 9.71428 21.6667 10.0196 21.6667 10.4V18.2857H26.3755C26.4911 18.2857 26.5969 18.3577 26.6441 18.4665C26.6875 18.5804 26.6667 18.7036 26.5781 18.8L20.2135 25.9196C20.1198 26.0161 19.8698 26.0107 19.7969 25.9304L13.4167 18.7946C13.3333 18.7036 13.3125 18.5804 13.3542 18.4679ZM29.1667 30.2857H10.8333C10.3729 30.2857 10 30.6693 10 31.1429C10 31.6164 10.3729 32 10.8333 32H29.1667C29.625 32 30 31.6166 30 31.1429C30 30.6691 29.625 30.2857 29.1667 30.2857Z",
    fill: "#3ECF8E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.98f75066da47886b56f1859546cca0d2.svg";
export { ForwardRef as ReactComponent };